const servers = {
    localhost1: {
        env: 'test',
        url: '//172.22.109.156:9004',
        ucenterLoginUrl: 'https://i-test.g7.com.cn/passport/login.html',
        ucenterLogoutUrl: 'https://i-test.g7.com.cn/passport/logout.html',
        ucenterPhoneUrl: 'https://i-test.g7.com.cn/passport/bind/phone.html',
        ucenterEmailUrl: 'https://i-test.g7.com.cn/passport/bind/email.html',
        // url: '//yapi.demo.ued.g7s.chinawayltd.com/mock/330',
        id: 'bzqk04j',
        skey: 'BedlhxkLDvilWh6e1lToknAXPUkg2qOp',
        // sandbox: {
        //     url: '//172.22.32.220:5555',
        //     ucenterLoginUrl: 'https://i-test.g7.com.cn/passport/login.html',
        //     ucenterLogoutUrl: 'https://i-test.g7.com.cn/passport/logout.html',
        //     ucenterProfileUrl: 'https://i-test.g7.com.cn/reset.html',
        //     id: 'bzqk04j',
        //     skey: 'BedlhxkLDvilWh6e1lToknAXPUkg2qOp'
        // }
    },
    localhost: {
        env: 'test',
        url: '//dsp.test.chinawayltd.com/vega-gw/rest',
        ucenterLoginUrl: 'https://i-test.g7.com.cn/passport/login.html',
        ucenterLogoutUrl: 'https://i-test.g7.com.cn/passport/logout.html',
        ucenterPhoneUrl: 'https://i-test.g7.com.cn/passport/bind/phone.html',
        ucenterEmailUrl: 'https://i-test.g7.com.cn/passport/bind/email.html',
        // url: '//yapi.demo.ued.g7s.chinawayltd.com/mock/330',
        id: 'bzqk04j',
        skey: 'BedlhxkLDvilWh6e1lToknAXPUkg2qOp',
        // sandbox: {
        //     url: '//172.22.32.220:5555',
        //     ucenterLoginUrl: 'https://i-test.g7.com.cn/passport/login.html',
        //     ucenterLogoutUrl: 'https://i-test.g7.com.cn/passport/logout.html',
        //     ucenterProfileUrl: 'https://i-test.g7.com.cn/reset.html',
        //     id: 'bzqk04j',
        //     skey: 'BedlhxkLDvilWh6e1lToknAXPUkg2qOp'
        // }
    },
    'docopenapi.test.chinawayltd.com': {
        env: 'test',
        url: '//dsp.test.chinawayltd.com/vega-gw/rest',
        ucenterLoginUrl: 'https://i-test.g7.com.cn/passport/login.html',
        ucenterLogoutUrl: 'https://i-test.g7.com.cn/passport/logout.html',
        ucenterPhoneUrl: 'https://i-test.g7.com.cn/passport/bind/phone.html',
        ucenterEmailUrl: 'https://i-test.g7.com.cn/passport/bind/email.html',
        id: 'bzqk04j',
        skey: 'BedlhxkLDvilWh6e1lToknAXPUkg2qOp',
        // sandbox: {
        //     url: '//172.22.32.220:5555',
        //     ucenterLoginUrl: 'https://i-test.g7.com.cn/passport/login.html',
        //     ucenterLogoutUrl: 'https://i-test.g7.com.cn/passport/logout.html',
        //     ucenterProfileUrl: 'https://i-test.g7.com.cn/reset.html',
        //     id: 'bzqk04j',
        //     skey: 'BedlhxkLDvilWh6e1lToknAXPUkg2qOp'
        // }
    },
    'demo.g7s.chinawayltd.com': {
        env: 'demo',
        url: '//172.16.2.136:5555',
        ucenterLoginUrl: 'https://i-demo.g7.com.cn/passport/login.html',
        ucenterLogoutUrl: 'https://i-demo.g7.com.cn/passport/logout.html',
        ucenterPhoneUrl: 'https://i-demo.g7.com.cn/passport/bind/phone.html',
        ucenterEmailUrl: 'https://i-demo.g7.com.cn/passport/bind/email.html',
        id: 'brxeh8m',
        skey: 'urJ39BUWtaSqkNZ9kbDv7C71vit5i6tY',
        // sandbox: { // demo无沙箱环境，使用test环境的key
        //     url: '//172.22.32.220:5555',
        //     ucenterLoginUrl: 'https://i-demo.g7.com.cn/passport/login.html',
        //     ucenterLogoutUrl: 'https://i-demo.g7.com.cn/passport/logout.html',
        //     ucenterProfileUrl: 'https://i-demo.g7.com.cn/reset.html',
        //     id: 'bzqk04j',
        //     skey: 'BedlhxkLDvilWh6e1lToknAXPUkg2qOp'
        // }
    },
    'openapi.huoyunren.com': {
        env: 'online',
        url: '//vega.huoyunren.com',
        ucenterLoginUrl: 'https://i.g7.com.cn/passport/login.html',
        ucenterLogoutUrl: 'https://i.g7.com.cn/passport/logout.html',
        ucenterPhoneUrl: 'https://i.g7.com.cn/passport/bind/phone.html',
        ucenterEmailUrl: 'https://i.g7.com.cn/passport/bind/email.html',
        id: 'b4nv7et',
        skey: 'aehAGjgcxiJyq0R2e5hNInmu0qrvorq1',
        // sandbox: { // 线上沙箱环境使用demo的key+id
        //     url: '//dsp.demo.chinawayltd.com/vega-gw/rest',
        //     ucenterLoginUrl: 'https://i.g7.com.cn/passport/login.html',
        //     ucenterLogoutUrl: 'https://i.g7.com.cn/passport/logout.html',
        //     ucenterProfileUrl: 'https://i.g7.com.cn/reset.html',
        //     id: 'brxeh8m',
        //     skey: 'urJ39BUWtaSqkNZ9kbDv7C71vit5i6tY'
        // }
    }
};

export default servers;



// WEBPACK FOOTER //
// ./src/configs/servers.js